"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentTimestamp = void 0;
const getCurrentTimestamp = () => Date.now();
exports.getCurrentTimestamp = getCurrentTimestamp;
//# sourceMappingURL=date.js.map